const norwegianSpecialLetters = ['æ', 'ø', 'å'];
const numericPattern = /^\d+$/;

export function compareCageNames(a: string, b: string): number {
    const aTrimmed = a.trim();
    const bTrimmed = b.trim();

    const isNumericA = numericPattern.test(aTrimmed);
    const isNumericB = numericPattern.test(bTrimmed);

    if (isNumericA && isNumericB) {
        return Number(aTrimmed) - Number(bTrimmed);
    }

    if (isNumericA) return -1;
    if (isNumericB) return 1;

    const aFirstChar = aTrimmed.charAt(0).toLowerCase();
    const bFirstChar = bTrimmed.charAt(0).toLowerCase();

    const aIsSpecial = norwegianSpecialLetters.includes(aFirstChar);
    const bIsSpecial = norwegianSpecialLetters.includes(bFirstChar);

    if (aIsSpecial && bIsSpecial) {
        return aTrimmed.localeCompare(bTrimmed);
    }

    if (aIsSpecial) return -1;
    if (bIsSpecial) return 1;

    return aTrimmed.localeCompare(bTrimmed);
}
